module.exports = __webpack_public_path__ + "static/media/add-video.88a2918f.png";